module.exports = __webpack_public_path__ + "static/media/a1.a7e40f8c.jpg";